import { ICancellationReason, IPauseReason } from "@smartrr/shared/entities/CancellationRelationship";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";

export interface IRetentionReducerState {
  arePauseReasonsInitialized: boolean;
  areCancellationReasonsInitialized: boolean;
  isLoading: boolean;
  isEnabled: boolean;
  cancellationReasons: ICancellationReason[];
  pauseReasons: IPauseReason[];
}

const initialState: IRetentionReducerState = {
  areCancellationReasonsInitialized: false,
  arePauseReasonsInitialized: false,
  isLoading: true,
  isEnabled: false,
  pauseReasons: [],
  cancellationReasons: [],
};

export const retentionReducer: CustomerSubReducer<IRetentionReducerState> = (
  state = initialState,
  action
): IRetentionReducerState => {
  switch (action.type) {
    case "LOADING_CANCELLATION_REASONS":
    case "LOADING_PAUSE_REASONS": {
      return {
        ...state,
        isLoading: true,
      };
    }

    case "ERROR_LOADING_CANCELLATION_REASONS":
    case "ERROR_LOADING_PAUSE_REASONS": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "LOADED_CANCELLATION_REASONS": {
      return {
        ...state,
        isLoading: false,
        areCancellationReasonsInitialized: true,
        cancellationReasons: action.payload.cancellationReasons,
      };
    }

    case "LOADED_PAUSE_REASONS": {
      return {
        ...state,
        isLoading: false,
        arePauseReasonsInitialized: true,
        pauseReasons: action.payload.pauseReasons,
      };
    }

    case "LOADED_ORGANIZATION_PLAN": {
      return {
        ...state,
        isLoading: false,
        isEnabled: !!action.payload.accountPlan.features.RETENTION,
      };
    }
    default: {
      return state;
    }
  }
};
